import { render, staticRenderFns } from "./VacancyCreate.vue?vue&type=template&id=20504fa8&"
import script from "./VacancyCreate.vue?vue&type=script&lang=js&"
export * from "./VacancyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports